import CarpayPaymentFlowContext from '@context/CarpayPaymentFlow/CarpayPaymentContext'
import { useContext } from 'react'

const useCarpayPaymentFlow = () => {
    const context = useContext(CarpayPaymentFlowContext)

    if (!context) {
        throw new Error('useCarpayPaymentFlow must be used within a CarpayPaymentFlowProvider')
    }

    return context
}

export default useCarpayPaymentFlow
